import React, { Fragment } from 'react';
import ReactModal from 'react-modal';
import TaskSection from './TaskSection';
import CompleteTaskForm from './CompleteTaskForm';
import ScheduleService from '../../../services/ScheduleService';
import TaskService from '../../../services/TaskService';

const modelStyles = {
  overlay: {
    textAlign: "center"
  },
  content: {
    padding: 0,
    left: "auto",
    right: "auto",
    bottom: "auto",
    textAlign: "right",
    display: "inline-block",
    width: "400px"
  }
};

class TaskSectionList extends React.Component {

  constructor(props) {
    super(props);

    this.handleOpenModal = this.handleOpenModal.bind(this);
    this.handleCloseModal = this.handleCloseModal.bind(this);
    this.handleDelete = this.handleDelete.bind(this);
    this.handleCreate = this.handleCreate.bind(this);
    this.handleComplete = this.handleComplete.bind(this);

    this.state = {
      projectId: null,
      sections: [],
      showModal: false,
      selectedTask: null
    }
  }

  componentDidMount() {
    this.setState({ projectId: this.props.projectId }, () => this.loadData());
  }

  loadData() {

    if (this.state.projectId > 0) {

      return ScheduleService
        .getTaskSections(this.props.projectType)
        .then(sections => {
          return { sections: [...sections] };
        })
        .then(response => {
          return TaskService
            .getTasks({ projectId: this.props.projectId })
            .then(tasks => {
              if (tasks.items.length > 0) {
                tasks.items.forEach(element => {
                  const parent = response.sections.find(x => x.id === element.attributes.categoryId);
                  if (parent) {
                    if (!parent.tasks) {
                      parent.tasks = [];
                    }
                    parent.tasks.push(element);
                  }
                });
              }
              return response;
            });
        })
        .then(mergedResponse => {
          return this.setState({
            sections: [...mergedResponse.sections]
          });
        })
        .catch(error => {
          console.log(error);
        });
    }
  }

  handleOpenModal(task) {
    this.setState({ showModal: true, selectedTask: task });
  }

  handleCloseModal() {
    this.setState({ showModal: false, selectedTask: null });
  }

  handleDelete(task) {

    if (task && task.id) {
      return TaskService
        .deleteTask(task.id)
        .then(() => this.loadData())
        .catch(error => {
          console.log(error);
        });
    }
  }

  handleCreate(task) {

    if (task) {
      const newTask = Object.assign({}, task);
      newTask.projectId = this.state.projectId;

      return TaskService
        .createTask({ attributes: { ...newTask } })
        .then(() => this.loadData())
        .catch(error => {
          console.log(error);
        });
    }
  }

  handleComplete(data) {

    if (data) {

      return TaskService.
        completeTask(data)
        .then(() => {
          this.setState({
            showModal: false,
            selectedTask: null
          }, () => this.loadData());
        });
    }
  }

  render() {

    const { section, projectId, projectType, onDelete, onCreate, onComplete, ...rest } = this.props;

    return (
      <Fragment>
        {this.state.sections && this.state.sections.length > 0 &&
          this.state.sections.map((section, index) => (
            <TaskSection
              {...rest}
              key={index}
              section={section}
              projectId={this.state.projectId}
              onDelete={this.handleDelete}
              onCreate={this.handleCreate}
              onComplete={this.handleOpenModal} />
          ))}
        <ReactModal
          isOpen={this.state.showModal}
          contentLabel="Complete Task"
          onRequestClose={this.handleCloseModal}
          ariaHideApp={false}
          style={modelStyles}>
          <CompleteTaskForm
            task={this.state.selectedTask}
            onSubmit={this.handleComplete}
            onCancel={this.handleCloseModal} />
        </ReactModal>
      </Fragment>
    );
  }
}

export default TaskSectionList;



// WEBPACK FOOTER //
// ./src/components/projects/Tasks/TaskSectionList.js